export default "/wp-content/themes/onnit/script/cart/dist/abPreOverrideMobile-0c318f82.png";